<template>
    <v-container>
        <div v-if="ready">
            <SearchResultsTable :standards="standards" :sortable="false" :area-of-need-columns="isAreaOfNeed" :expandable="false"></SearchResultsTable>
        </div>
        <div class="text-center">
            <v-btn tile large color="primary" class="large-button px-12" @click="allStandards()">
                <span class="title">Search All Standards</span>
                <v-icon right>mdi-arrow-right</v-icon>
            </v-btn>
        </div>
    </v-container>
</template>

<script>
    import { get } from 'vuex-pathify';
    import SearchResultsTable from '@/components/SearchResultsTable';
    import router from '@/router';

    export default {
        name: 'Standard',
        components: { SearchResultsTable },
        data: () => ({
            ready: false
        }),
        computed: {
            standards: get('standards'),
            isAreaOfNeed() {
                return this.standards?.length ? 'Area of Need' === this.standards[0].status : false;
            }
        },
        mounted() {
            this.$store.commit('setHexFilter', this.$route.params.hex || '');
            this.$store.dispatch('search').then(() => {
                if (this.standards?.length) {
                    this.standards[0].isExpanded = true;
                    this.ready = true;
                } else {
                    this.allStandards();  
                }
            });
        },
        methods: {
            allStandards() {
                this.$store.commit('resetFilters', true);
                this.$store.dispatch('search').then(() => {
                    router.push({ path: this.$store.get('searchPath') });
                });
            }
        }
    };
</script>
